import React from 'react';
import { BiLink } from "react-icons/bi";
import { scrollToProjects} from '../utils/scroll';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1,
    slidesToSlide: 1 
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
    slidesToSlide: 1 
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1 
  }
};

export default function Projects() {

  return (
    <article id="projects"className='bg-background2 w-full h-auto pb-20 relative' >
      <div className='flex flex-row justify-center text-6xl font-banner-font text-black py-24 cursor-pointer' onClick={scrollToProjects}>
        <BiLink  className='text-white mr-4'/>
        <h2 className='border-b border-solid border-gray-300 pb-2 text-white'>PROJECTS</h2>
        <div className='project-leaf-parent absolute -top-12 right-0'>
          <img className='project-leaf' src="https://www.demimaisons.be/themes/demimaisons/assets/images/shape-03.png" alt="Shape leaf" />
        </div>
      </div>

      <ul className="w-full">
        <li className='w-5/6 bg-white text-center mx-auto '>
          <div>
            <h3 className='text-2xl font-bold pt-3 mb-3'>온라인 쇼핑몰</h3>
            <div className='flex flex-col lg:flex-row '>
            <section className='w-full flex p-2 px-2 lg:w-1/2 items-center'>
                <Carousel
                  className='w-full'
                  swipeable={true}
                  draggable={false}
                  showDots={true}
                  responsive={responsive}
                  arrows
                  ssr={true} 
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={6000}
                  keyBoardControl={true}
                  customTransition="all 0.5s linear"
                  transitionDuration={500}
                >
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou1.png" alt="kiyou 1" />
                  </a>
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou2.png" alt="kiyou 2" />
                  </a>
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou3.png" alt="kiyou 3" />
                  </a>
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou4.png" alt="kiyou 4" />
                  </a>
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou5.png" alt="kiyou 5" />
                  </a>
                  <a href="https://kiyou-eshop.netlify.app/">
                    <img className="w-full" src="/images/projects/kiyou6.png" alt="kiyou 6" />
                  </a>
              </Carousel>
            </section>

              <div className='p-3 lg:ml-3 w-full lg:w-1/2 text-left'>
                <p> 관리자와 사용자의 <b>권한이 구분</b>되어 있는 <b>React</b> 기반의 20, 30대 여성 온라인 쇼핑몰 웹사이트입니다 <b>(SPA)</b>.</p>


                <p className='mt-5'>
                  <b>🔍 TanStack Query (서버 상태 관리 라이브러리)</b> 사용 이유 : 데이터 패칭, 캐싱 및 업데이트 등에 용이한 기능을 사용하여 기존 커스텀훅의 한계를 보안하여 <b>불필요한 네트워크 요청</b> 을 줄이고 <b>상태관리</b>에 효울적
                </p>

                <p className='mt-5'>
                  🔍 <b>Tailwind </b>사용 이유 : 많이 사용되는 디자인들을 직관적인 클래스 이름으로 제공하여 손쉽게 원하는 디자인 구현 가능. 태그와 스타일을 함께 사용하여 스타일을 빠르고 쉽게 적용 가능 
                </p>
                <div className='mt-5'>
                  <p>🔍 <b>개발 시 중점 사항</b> : </p>
                  <p>- <b>재사용 컴포넌트 생성 및 사용</b>: 최대한 재사용 가능한 컴포넌트를 설계하여 코드 중복을 줄이고 유지보수성을 높임</p>
                  <p>- <b>Logic과 UI의 분리</b>: 비즈니스 로직과 사용자 인터페이스를 최대한 분리하여 코드의 가독성과 관리 효율성을 향상시킴</p>
                  <p>- <b>Context API 사용</b>: 로그인 상태 체크 제외, 전역 상태로 관리할 변수가 많지 않고 복잡하지 않아, 별도의 상태 관리 라이브러리 대신 Context API를 사용</p>
                </div>

                <div className='mx-3 my-3'>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ 주요 기능</p>
                    <p className='w-3/4 '> 제품 등록 (관리자), 제품 탐색, 필터링, 카트에 담기, 로그인 / 로그아웃 </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Github</p>
                    <a href="https://github.com/lee00777/kiyou-eshop" className='w-3/4 text-blue-500'>https://github.com/lee00777/kiyou-eshop</a>          
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ URL</p>
                    <a href="https://kiyou-eshop.netlify.app/" className='w-3/4 text-blue-500'>https://kiyou-eshop.netlify.app/</a>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Frontend</p>
                    <p className=''>React,TanStack Query,Tailwind CSS </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Backend</p>
                    <p className=''>Firebase Authentication</p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Database</p>
                    <p className=''>Firebase Realtime Database</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li className='w-5/6 bg-white text-center mx-auto mt-20'>
          <div>
            <h3 className='text-2xl font-bold pt-3 mb-3'>유투브 클롭앱</h3>
            <div className='flex flex-col lg:flex-row  '>
              <section className='w-full flex p-2 px-2 lg:w-1/2'>
                <Carousel
                  className='w-full object-cover'
                  swipeable={true}
                  draggable={false}
                  showDots={true}
                  responsive={responsive}
                  arrows
                  ssr={true} 
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={5000}
                  keyBoardControl={true}
                  customTransition="all 0.5s linear"
                  transitionDuration={500}
                  >
                  <a href="https://gyuyoung-youtube-app.netlify.app/">
                    <img className="w-full" src="/images/projects/youtube1.png" alt="youtube 1" />
                  </a>
                  <a href="https://gyuyoung-youtube-app.netlify.app/">
                    <img className="w-full" src="/images/projects/youtube2.png" alt="youtube 2" />
                  </a>
                  <a href="https://gyuyoung-youtube-app.netlify.app/">
                    <img className="w-full" src="/images/projects/youtube3.png" alt="youtube 3" />
                  </a>
                  <a href="https://gyuyoung-youtube-app.netlify.app/">
                    <img className="w-full" src="/images/projects/youtube4.png" alt="youtube 4" />
                  </a>
                </Carousel>
              </section>
              <div className='p-3 lg:ml-3 w-full lg:w-1/2 text-left content-center'>
                <p> <b>유투브 Open API</b>를 활용한 React 기반의 반응형 유투브 클론앱입니다 <b>(SPA)</b>.</p>
                <p className='mt-5'> 실시간 인기 동영상 및 카테고리별 동영상을 탐색할 수 있으며, 검색을 통한 간편 검색도 가능합니다.
                동영상 클릭 시, 해당 채널의 다른 동영상들이 연관 동영상으로 추천되며, 기존 유투브와 동일하게 다른 사용자들의 답글도 볼 수 있습니다. </p>
                <p className='mt-5'> <b>React-Query</b>와 <b>React Hooks</b> 활용에 초점을 두어 개발 하였습니다.</p>
                <div className='mx-3 my-3'>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ 주요 기능</p>
                    <p className='w-3/4'> 실시간 인기 동영상 추천, 동영상 검색, 동영상 탐색, 연관 동영상 추천, 답글 탐색, 좋아요/싫어요 버튼 </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ URL</p>
                    <a href="https://gyuyoung-youtube-app.netlify.app/" className='w-3/4 text-blue-500'>https://gyuyoung-youtube-app.netlify.app/</a>          
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Frontend</p>
                    <p className='w-3/4'>React, React Query,Tailwind CSS </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Database</p>
                    <p className='w-3/4'>Firebase Realtime Database</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>

        <li className='w-5/6 bg-white text-center mx-auto mt-20 '>
          <div>
            <h3 className='text-2xl font-bold pt-3 mb-3'>맞춤형 웰빙 플래너</h3>
            <p className='mb-3'>팀 프로젝트</p>
            <div className='flex flex-col lg:flex-row  '>
              <section className='w-full flex p-2 px-2 lg:w-1/2'>
                <Carousel
                  className='w-full object-cover'
                  swipeable={true}
                  draggable={false}
                  showDots={true}
                  responsive={responsive}
                  arrows
                  ssr={true} 
                  infinite={true}
                  autoPlay={true}
                  autoPlaySpeed={5000}
                  keyBoardControl={true}
                  customTransition="all 0.5s linear"
                  transitionDuration={500}
                >
                  <a className="w-full" href="https://www.algonquincollege.com/applied-research/2022/03/balanced-brain/">
                    <img className="w-full" src="/images/projects/pwa1.png" alt="pwa 1" />
                  </a>
                  <a className="w-full" href="https://www.algonquincollege.com/applied-research/2022/03/balanced-brain/">
                    <img className="w-full" src="/images/projects/pwa2.png" alt="pwa 2" />
                  </a>
                  <a className="w-full" href="https://www.algonquincollege.com/applied-research/2022/03/balanced-brain/">
                    <img className="w-full" src="/images/projects/pwa3.png" alt="pwa 3" />
                  </a>
                  <a className="w-full" href="https://www.algonquincollege.com/applied-research/2022/03/balanced-brain/">
                    <img className="w-full" src="/images/projects/pwa4.png" alt="pwa 4" />
                  </a>
                </Carousel>
              </section>
              <div className='p-3 lg:ml-3 w-full lg:w-1/2 text-left content-center'>
                <p> 건강한 습관 변화를 이끌어내기 위해 개발된 <b>PWA 기반</b> 웹 애플리케이션입니다</p>
                <p className='mt-3'> 캐나다 오타와에 위치한 신경클리닉 Renew Neurotherapy를 위해 개발한 웹 애플리케이션으로,
                  사용자들의 일상 목표 설정 / 결과 기록 / 공유를 주 목표로 합니다. </p>
                <p className='mt-3'>관리자, 상담사, 사용자의 <b>권한이 구분</b>되어 있으며 각각 다른 기능과 데이터 접근 권한을 가지고 있으며, 모바일부터 데스크탑까지 다양한 장치에서 사용할 수 있도록 <b>반응형</b>으로 설계하였습니다. </p>
                <div className='mx-3 my-3'>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ 역할 </p>
                    <p className='w-3/4'>사용자 인터페이스 담당. 도넛 차트와 바 차트를 포함한 <b>데이터 시각화 구현</b> 및 애니메이션과 흥미로운 인터랙션을 추가하여 사용자들이 지속적으로 흥미를 갖고 사용할 수 있도록 유도  </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ 주요 기능</p>
                    <p className='w-3/4'> 상담사 및 사용자 데이터 접근(관리자), 사용자 데이터 접근(상담사), 계정 추가기능(관리자/상담사), 사용자 목표 관리 및 진행상황 체크(관리자/상담사), 진행상황 공유(사용자) </p>
                  </div>
                  <div className='flex w-full overflow-hidden text-ellipsis '>
                    <p className='w-1/4'>✅ URL</p>
                    <a href="https://www.algonquincollege.com/applied-research/2022/03/balanced-brain/" className='w-3/4 text-blue-500'>https://www.algonquincollege.com/applied-research/balanced-brain/</a>       
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Frontend</p>
                    <p className='w-3/4'>Next.js, Chart.js, Tailwind, CSS </p>
                  </div>
                  <div className='flex w-full'>
                    <p className='w-1/4'>✅ Database</p>
                    <p className='w-3/4'>Firebase Realtime Database</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>

  </article>
  );
}

